// extracted by mini-css-extract-plugin
export default {"titleHeader":"styles_titleHeader__NDpi1","intervals":"styles_intervals__s28TE"};